<template>
  <form v-on:submit="save">
    <div class="card card-info" runat="server" v-show="showgrid === 'false'">
      <div class="card-header with-border">
        <h3 class="card-title">Department Coordinator</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class=" card-body">
        <div class="row">
        
              <div class="col-md-6">
                <label>Program *</label>
                <select class="form-control" v-model="ProgramID" required v-on:change="progChange()" v-bind:disabled="FYP.FYPManagementID != 0">
                  <option value="">--Select Program--</option>
                  <option v-for="item in program" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                </select>
              </div>
              <div class="col-md-6" v-show="grid === 'show'">
                <label>Type *</label>
                <select class="form-control" v-model="FYP.Type" required>
                  <option value="">--Select Type--</option>
                  <option value="Project">Project</option>
                  <option value="Research/Thesis">Research/Thesis</option>
                </select>
              </div>
              <div class="col-md-12" v-show="grid === 'show'">
                <div class="row">
                  <div class="col-md-12">
                    <label>Project/Thesis Title *</label>
                    <input class="form-control" v-model="FYP.Title" required/>
                  </div>

                  <div class="col-md-12">
                    <label>Description</label>
                    <textarea class="form-control" v-model="FYP.Discription"></textarea>
                  </div>

                  <div class="col-md-12" style="margin-top: 20px">
                    <label>Student(s) (Selected Students <b>{{Students.filter((x) => {return x.Selected;}).length}}</b>)</label>
                    <div class="table-responsive">
                      <table class="table table-bordered table-sm" id="stTable">
                        <thead class="bg-info">
                          <tr>
                            <th width="10%">Sr. No.</th>
                            <th width="15%">Roll No</th>
                            <th width="30%">Name</th>
                            <th width="30%">Father Name</th>
                            <th width="15%">Phone No</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, ind) in Students">
                            <td>{{ind+1}}</td>
                            <td>
                              <label class="checkbox" style="margin-left: 20px">
                                <input type="checkbox" v-bind:value="item.Selected" v-model="item.Selected" style="margin-top: 0px">
                                {{item.RollNo}}
                              </label>
                            </td>
                            <td>{{item.Name}}</td>
                            <td>{{item.FathersName}}</td>
                            <td>{{item.ContactNo}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                  </div>
                  <div class="col-md-12">
                    <label>Supervisor / Co-Supervisor (Selected Supervisors / Co-Supervisor <b>{{Supervisor.filter((x) => {return x.Selected;}).length}}</b>)</label>
                    <div class="table-responsive">
                      <table class="table table-bordered table-sm" id="supTable">
                        <thead class="bg-info">
                          <tr>
                            <th width="10%">Sr. No.</th>
                            <th width="35%">Name</th>
                            <th width="10%">Emp Code</th>
                            <th width="35%">Designation</th>
                            <th width="10%">Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, ind) in Supervisor">
                            <td>{{ind+1}}</td>
                            <td>
                              <label class="checkbox" style="margin-left: 20px">
                                <input type="checkbox" v-bind:value="item.Selected" v-model="item.Selected" style="margin-top: 0px">
                                {{item.Name}}
                              </label>
                            </td>
                            <td>{{item.EmpCode}}</td>
                            <td>{{item.Designation}}</td>
                            <td>
                              <select class="form-control" v-model="item.SupervisorType" required v-bind:disabled="!item.Selected" v-on:change="CheckData()">
                                <option value="">--Select Type--</option>
                                <option value="Supervisor">Supervisor</option>
                                <option value="Co-Supervisor">Co-Supervisor</option>
                              </select>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                  </div>
                  <div class="col-md-12">
                    <label>Examiner(s) (Selected Examiner <b>{{ExternalSupervisor.filter((x) => {return x.Selected;}).length}}</b>)</label>
                    <div class="table-responsive">
                      <table class="table table-bordered table-sm" id="exsupTable">
                        <thead class="bg-info">
                          <tr>
                            <th width="10%">Sr. No.</th>
                            <th width="20%">Name</th>
                            <th width="20%">Institute</th>
                            <th width="10%">Designation</th>
                            <th width="10%">Area of Specialization</th>
                            <th width="15%">Email</th>
                            <th width="15%">Contact No</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, ind) in ExternalSupervisor">
                            <td>{{ind+1}}</td>
                            <td>
                              <label class="checkbox" style="margin-left: 20px">
                                <input type="checkbox" v-bind:value="item.Selected" v-model="item.Selected" style="margin-top: 0px">
                                {{item.Name}}
                              </label>
                            </td>
                            <td>{{item.Institute}}</td>
                            <td>{{item.Designation}}</td>
                            <td>{{item.Specialization}}</td>
                            <td>{{item.Email}}</td>
                            <td>{{item.ContactNo}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                  </div>
                </div>
              </div>
         
        </div>
      </div>
      <!--Button -->
      <div class="card-footer">
        <input type="submit" value="Save" class="btn btn-success float-right" v-show="grid === 'show'"/>
        <!--<button class="btn btn-success" style="width: 120px" v-show="grid === 'show'" type="submit">Save</button>-->
        <button class="btn btn-primary" style="width: 120px" type="button" v-on:click="clear()">Back to List</button>
      </div>
    </div>
    <div class="card card-info" runat="server" v-show="showgrid === 'true'">
      <div class="card-header">
        <h3 class="card-title"> <button v-on:click="changestate()" type="button" class=" float-right btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button></h3>
       
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="row">
          <div class="col-md-12" >
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-color" id="bs4">
                <thead class="bg-info">
                  <tr>
                    <th width="30%">Program</th>
                    <th width="10%">Semester</th>
                    <th width="25%">Title</th>
                    <th width="25%">Type</th>
                    <th width="10%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in FYPManagement">
                    <td>{{item.ProgramName}}</td>
                    <td>{{item.Semester}}</td>
                    <td>{{item.Title}}</td>
                    <td>{{item.Type}}</td>
                    <td>
                      <button class="btn" style="border: none; color: green; background-color: transparent" v-on:click="edit(item.FYPManagementID)"><i class="fa fa-edit fa-2x"></i></button>
                      <button class="btn" style="border: none; color: dodgerblue; background-color: transparent" v-on:click="print(item.FYPManagementID)"><i class="fa fa-print fa-2x"></i></button>
                      <i class="fa fa-2x fa-edit" v-on:click="edit(item.FYPManagementID)" hidden></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </form>
</template>


<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        ProgramID: '',
        ActiveSemesterID: '',
        program: [],
        session: [],
        grid: 'hide',
        showgrid: 'true',
        Students: [],
        Supervisor: [],
        FYPManagement: [],
        FYP: {
          FYPManagementID: 0,
          Type: '',
          Title: '',
          Discription: '',
        },
        ExternalSupervisor: [],
      }
    },
    created: function () {
      this.pageload();
    },

    updated: function () {
      $('#bs4').DataTable();
      $('#stTable').DataTable();
      $('#supTable').DataTable();
      $('#exsupTable').DataTable();
    },
    methods: {
      changestate() {
        this.showgrid = 'false';
      },
      clear() {
        window.location.reload();
      },
      progChange() {
        var vm = this;
        axios.post('/api/DCApi/sessionChange?progID=' + vm.ProgramID)
          .then(function (response) {
            $('#stTable').DataTable().destroy();
            $('#supTable').DataTable().destroy();
            $('#exsupTable').DataTable().destroy();
            vm.Students = response.data.lst;
            vm.Supervisor = response.data.teach;
            vm.ExternalSupervisor = response.data.extSuper;
            vm.grid = 'show';
          })
      },
      pageload() {
        var vm = this;
        axios.post('/api/DCApi/loadProgram')

          .then(function (response) {
            if (response.data.status) {

              vm.program = response.data.programs;
            }
          })
        axios.post('/api/DCApi/loadFYPManagement')
          .then(function (response) {
            if (response.data.status) {
              vm.FYPManagement = response.data.lst;
              $('#bs4').DataTable().destroy();
            }
      
          })
      },

      save(e) {

        e.preventDefault();
        if (this.Students.filter((x) => { return x.Selected; }).length == 0) {
          toastr.error("Atleast one Student Required");
          return;
        }
        startReq();
        var vm = this;
        axios.post('/api/DCApi/saveFYP', {
          obj: vm.FYP,
          std: vm.Students,
          sup: vm.Supervisor,
          ext: vm.ExternalSupervisor,
        })
          .then(function (response) {
            if (response.data.status) {
              endReq();
              toastr.success(response.data.msg);
              window.location.reload();
            }
            else {
              toastr.error(response.data.msg);
            }
          })  


      },
      edit(ID) {
        var vm = this;
        axios.post('/api/DCApi/editFYP?id=' + ID)

          .then(function (response) {
            if (response.data.status) { 
            axios.post('/api/DCApi/loadProgram')
              .then(function (response) {
                vm.program = response.data.programs;
              })
            vm.FYP = response.data.lst;
            $('#stTable').DataTable().destroy();
            $('#supTable').DataTable().destroy();
            $('#exsupTable').DataTable().destroy();
            vm.Students = vm.FYP.Student;
            vm.Supervisor = vm.FYP.Teacher;
            vm.ExternalSupervisor = vm.FYP.External;
            vm.ProgramID = vm.FYP.ProgramID;
            vm.showgrid = 'false';
              vm.grid = 'show';
            }
            })

      },

      print(ID) {
        var vm = this;
        axios.post('/api/DCApi/printFYP?id=' + ID)
          .then(function (res) {
            endReq();
            window.open(res.data.url, '_blank');
          })
      },

    }
  })

  </script>



// WEBPACK FOOTER //
// src/components/DC/fypManagement.vue